module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Funksjonelle hjernespill","text":"Spill deg til en topptrent hjerne"},"en":{"title":"Functional brain games","text":"Stay ahead of change by gaming yourself to better days and a top-trained brain."}}')
  delete Component.options._Ctor
}
